import React, {useContext, useEffect, useState} from "react";
import {
    Box,
    Card,
    CardBody,
    CardHeader,
    Divider,
    Flex,
    Hide,
    Image,
    Spinner,
    Stack,
    Step,
    StepDescription,
    StepIcon,
    StepIndicator,
    StepNumber,
    Stepper,
    StepSeparator,
    StepStatus,
    StepTitle,
    Text,
    useSteps
} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import {ROUTES} from "../../../constants/routes-path";
import {CUSTOMER_LOGO} from "../../../constants/config";

import {steps} from "../../../utils/boat-utils";

import BoatLocationForm from "./Form/BoatLocationForm";
import BoatVehicleForm from "./Form/BoatVehicleForm";
import {boatService} from "../../../services/boatService";
import {useCustomToast} from "../../../components/CustomToast/CustomToast";
import {AuthContext} from "../../../contexts/AuthContext";

function BoatNew() {
    const {t} = useTranslation();
    const showToast = useCustomToast();
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    // const [currentBoat, setCurrentBoat] = useState(boatTest)
    const [currentBoat, setCurrentBoat] = useState({})

    const {activeStep, setActiveStep} = useSteps({
        index: 0,
        count: steps.length,
    })

    useEffect(() => {
        if (activeStep === 2) {
            saveBoat();
        }
    }, [activeStep]);

    const saveBoat = async () => {
        try {
            const boatData = {...currentBoat}

            const vehiclesPlates = currentBoat.veiculos.map((v) => v.placa);
            boatData.agenteId = user?.agente_id;
            boatData.agenteTransito = {
                agenteId: user?.agente_id,
                nome: user?.pessoa?.nome,
                matricula: user?.agente_matricula,
            };

            const status = 'RASCUNHO';

            const response = await boatService.create({
                agentId: user?.agente_id,
                status,
                vehiclesPlates,
                data: boatData,
            });

            showToast({title: t('boat.messages.success.save'), status: "success"});
            navigate(ROUTES.boatsEditPath.replace(":id", response.id));

        } catch (error) {
            showToast({title: t(error), status: "error"});
        }
    }

    const handleOnSubmit = (values) => {
        setCurrentBoat(getCurrentBoat(values));

        setActiveStep(step => step + 1);
    }

    const handleBack = () => {
        setActiveStep(step => step - 1);
    }

    const getCurrentBoat = (values) => {
        switch (activeStep) {
            case 0:
                return {...currentBoat, local: values}
            case 1:
                return {...currentBoat, veiculos: values.veiculos}
        }

        return currentBoat
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return <BoatLocationForm onSubmit={handleOnSubmit} values={currentBoat.local}/>
            case 1:
                return <BoatVehicleForm onSubmit={handleOnSubmit} onBack={handleBack} values={currentBoat.veiculos}/>
            default:
                return <Flex justify="center"><Spinner/></Flex>
        }
    }

    const renderedStep = getStepContent(activeStep)

    return (
        <Flex direction="column" pt={{sm: "125px", lg: "75px"}} w="100%">
            <Card px="0px" pt="10px" mb="24px">
                <CardHeader pt="22px">
                    <Flex gap="8" justify="column" pt="20px" px="40px">
                        <Flex gap="4" justify="space-between" w="100%">
                            <Text fontSize="lg" fontWeight="bold">{t('boat.report.title')}</Text>
                            <Text fontSize="lg"
                                  fontWeight="bold">{t('boat.report.boat-number')} # -</Text>
                        </Flex>
                    </Flex>
                    <Flex gap="8" justify="column" pt="20px" px="40px">
                        <Flex gap="4" justify="space-between" w="100%">
                            <Image
                                src={CUSTOMER_LOGO}
                                alt="Logo 2"
                                w="200px"
                                h="200px"
                                maxH="100px"
                                objectFit="contain"
                            />
                            <Text></Text>
                        </Flex>
                    </Flex>

                    <Flex gap="4" justify="center" py="20px">
                        <Divider borderColor="gray.300"/>
                    </Flex>

                    <Flex gap="1" justify="center" py="20px">
                        <Stepper index={activeStep} size='sm'>
                            {steps.map((step, index) => (
                                <Step key={index}>
                                    <StepIndicator>
                                        <StepStatus
                                            complete={<StepIcon/>}
                                            incomplete={<StepNumber/>}
                                            active={<StepNumber/>}
                                        />
                                    </StepIndicator>

                                    <Hide below="md">
                                        <Box>
                                            <StepTitle fontSize="sm" fontWeight="bold">{t(step.title)}</StepTitle>
                                            <StepDescription fontSize="sm">{t(step.subtitle)}</StepDescription>
                                        </Box>
                                    </Hide>

                                    <StepSeparator/>
                                </Step>
                            ))}
                        </Stepper>
                    </Flex>

                    <Flex gap="4" justify="center">
                        <Divider borderColor="gray.300"/>
                    </Flex>
                </CardHeader>
                <CardBody>
                    <Stack>
                        {renderedStep}
                    </Stack>
                </CardBody>
            </Card>
        </Flex>
    )
}

export default BoatNew;